import { app } from '@/services/firebaseService';
import { getFunctions, httpsCallable } from 'firebase/functions';

// Resolve URL at call time to allow test overrides
 
// Callable CF in us-east4

export async function bulkDeleteOffersViaAdminService(offerIds: string[]): Promise<{ success: boolean; deleted?: number; error?: string }>
{
  if (!Array.isArray(offerIds) || offerIds.length === 0) {
    return { success: false, error: 'No offer IDs provided' };
  }

  try {
    // Call callable CF bulkDeleteOffers
    const functions = getFunctions(app, 'us-east4');
    const callable = httpsCallable(functions, 'bulkDeleteOffers');
    const result = await callable({ offerIds });
    const data = result.data as any;
    return { success: !!data?.success, deleted: data?.deleted, error: data?.error };
  } catch (e: any) {
    const msg =
      (typeof e?.message === 'string' && e.message) ||
      (typeof e?.error === 'string' && e.error) ||
      (typeof e?.code === 'string' ? `Error: ${e.code}` : '') ||
      String(e);
    return { success: false, error: msg };
  }
}

export async function bulkDeleteFutureOffersForLocation(
  locationId: string
): Promise<{ success: boolean; deleted?: number; error?: string }> {
  if (!locationId?.trim()) {
    return { success: false, error: "Location ID is required" };
  }
  try {
    const functions = getFunctions(app, "us-east4");
    const callable = httpsCallable(functions, "bulkDeleteOffers");
    const result = await callable({ locationId, futureOnly: true });
    const data = result.data as any;
    return { success: !!data?.success, deleted: data?.deleted, error: data?.error };
  } catch (e: any) {
    const msg =
      (typeof e?.message === "string" && e.message) ||
      (typeof e?.error === "string" && e.error) ||
      (typeof e?.code === "string" ? `Error: ${e.code}` : "") ||
      String(e);
    return { success: false, error: msg };
  }
}

/** Delete all future non-placeholder sessions for all locations with providedByOrg == orgId. */
export async function bulkDeleteFutureOffersForOrganization(
  organizationId: string
): Promise<{ success: boolean; deleted?: number; error?: string }> {
  if (!organizationId?.trim()) {
    return { success: false, error: "Organization ID is required" };
  }
  try {
    const functions = getFunctions(app, "us-east4");
    const callable = httpsCallable(functions, "bulkDeleteOffers");
    const result = await callable({ organizationId, futureOnly: true });
    const data = result.data as any;
    return { success: !!data?.success, deleted: data?.deleted, error: data?.error };
  } catch (e: any) {
    const msg =
      (typeof e?.message === "string" && e.message) ||
      (typeof e?.error === "string" && e.error) ||
      (typeof e?.code === "string" ? `Error: ${e.code}` : "") ||
      String(e);
    return { success: false, error: msg };
  }
}

